import { companyForms } from '#/store/hooks/useForms/Company'
import { contractForms } from '#/store/hooks/useForms/Contract'
import { farmForms } from '#/store/hooks/useForms/Farm'
import { importForms } from '#/store/hooks/useForms/Import'
import { pagebuilderForms } from '#/store/hooks/useForms/Pagebuilder'
import { systemForms } from '#/store/hooks/useForms/System'
import { userForms } from '#/store/hooks/useForms/User'

function useForms() {
  return {
    ...farmForms,
    ...systemForms,
    ...userForms,
    ...companyForms,
    ...importForms,
    ...contractForms,
    ...pagebuilderForms,
  }
}

export { useForms }
